import {
  Component,
  Input,
  OnInit,
  ChangeDetectionStrategy,
  inject,
  DestroyRef,
  ChangeDetectorRef
} from '@angular/core';
import { Contract } from '@shared/entities/contract';
import { Machine } from '@shared/entities/machine';
import { tap } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ThemeService } from 'src/app/services/theme.service';

@Component({
  selector: 'app-icam-machine-alert-warning-recap',
  templateUrl: './icam-machine-alert-warning-recap.component.html',
  styleUrl: './icam-machine-alert-warning-recap.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IcamMachineAlertWarningRecapComponent implements OnInit {
  private _destroyRef = inject(DestroyRef);
  private _cdr = inject(ChangeDetectorRef);
  private _themeService = inject(ThemeService);

  isLight = true;
  machinesCount = 0;
  contractsCount = 0;
  @Input() isOpen = false;
  @Input() machines: Machine[] | null = [];
  @Input() contracts: Contract[] | null = [];

  constructor() {
    /* noop */
  }

  ngOnInit(): void {
    this.machinesCount = this.machines?.length || 0;
    this.contractsCount = this.contracts?.length || 0;

    this._themeService.isLight$
      .pipe(
        takeUntilDestroyed(this._destroyRef),
        tap((x) => {
          this.isLight = x;
          this._cdr.markForCheck();
        })
      )
      .subscribe();
  }
}
